/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

interface IInput {
    rank_type: string;
    group_id: number;
    page?: number;
    size?: number;
}

export interface IRankInfo {
    rank: number;
    total_points: number;
}

export interface IOutput extends IUserBaseInfo {
    name: string; // name 和基础数据结构不一致
    all_reach_rank: number;
    basic_rank: number;
    complete_rate: string;
    finish_time: string;
    last_update_time: number;
    total_points: number;
    excellent_rank: number;
    positive_rank: number;
    special_recognition_rank: number;
}

export const getCoursePointsRank = (data: IInput): Promise<IList<IOutput>> => {
    return fetchData(Api.GET_COURSE_POINTS_RANK, data).then((res: IList<IOutput>) => {
        return res;
    });
};

export const getCoursePointsRankSync = fetchDataSync(getCoursePointsRank);
